var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-title pulse"}),_c('div',{staticClass:"text-body pulse"}),_c('div',{staticClass:"text-details pulse mt-4"})])])
}]

export { render, staticRenderFns }